import React from 'react'
import Navbar from './containers/Navbar'
import { withTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'

const Topbar = ({ t }) => {
  const pathname = '/' + useLocation().pathname.split('/').slice(2).join('/')

  return (
    <div>
      <Navbar />
      {!(pathname === t('routes.not_found') || pathname === t('routes.privacy_notice') || pathname === t('routes.confirmation')) && (
        <div style={{ backgroundColor: '#eeeeee', height: '30pt' }}></div>
      )}
    </div>
  )
}

export default withTranslation('common')(Topbar)
